import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { EditableType } from '../../../../containers/Editor/constants';
import { EnrichmentType } from '../../../../containers/Editor/utils/indesignEditor/constants';
import { AdditionalPanelType, PanelType } from '../constants';
import { Label, LabelItem, Button } from './styles';

interface EditPanelLabelProps {
	type: PanelType;
	availableTypes: PanelType[];
	onClick: (type: PanelType) => void;
}

const panelTypeTranslationMap = {
	[EditableType.animation]: 'messages.animation',
	[EditableType.iframe]: 'messages.iframe',
	[EditableType.image]: 'messages.image',
	[EditableType.link]: 'messages.link',
	[EditableType.text]: 'messages.text',
	[EditableType.video]: 'messages.video',
	[EditableType.themes]: 'messages.themes',
	[EditableType.slider]: 'messages.slider',
	[EnrichmentType.openNewTab]: 'messages.open_in_new_tab',
	[EnrichmentType.openSameTab]: 'messages.open_in_same_tab',
	[EnrichmentType.popup]: 'messages.open_popup',
	[AdditionalPanelType.settings]: 'messages.settings',
};

const EditPanelLabel = ({ type, availableTypes, onClick }: EditPanelLabelProps) => (
	<Label className="prevent-drag">
		{availableTypes.map((panelType: PanelType) => {
			const isActive = panelType === type;

			return (
				<LabelItem key={panelType}>
					<Button
						type="button"
						isActive={isActive}
						disabled={isActive}
						onClick={() => onClick(panelType)}
					>
						<Translate value={panelTypeTranslationMap[panelType]} />
					</Button>
				</LabelItem>
			);
		})}
	</Label>
);

export default EditPanelLabel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/Label/index.tsx